import { getItemsFromCollection } from "directus/src/operations";
import { useQuery } from "@tanstack/react-query";

export const useJobsCount = (jobType, filters = {}) => {
  return useQuery({
    queryKey: ["jobs-count", jobType, filters],
    queryFn: async () => {
      const jobFilter = {
        type: { _eq: jobType },
        status: { _nin: ["archived", "cancelled"] },

        ...(filters?.jobs?.billables?.collected_date
          ? {
            billables: {
              collected_date: filters.jobs.billables.collected_date,
            },
          }
          : {}),

        ...(filters?.jobs?.employees?.employee?.department?._in
          ? {
            employees: {
              employee: {
                department: {
                  _in: filters.jobs.employees.employee.department._in,
                },
              },
            },
          }
          : {}),

        ...(filters?.sales_coordinator
          ? {
            project: {
              sales_coordinator: { _eq: filters.sales_coordinator._eq },
            },
          }
          : {}),

        ...(filters?.client
          ? { project: { client: { _eq: filters.client._eq } } }
          : {}),
      };

      jobFilter.billables.status = { _eq: "collected" };

      const query = {
        fields: ["id"],
        filter: jobFilter,
        limit: -1,
      };

      const response = await getItemsFromCollection("jobs", query);
      return response.length;
    },
    enabled: !!jobType,
  });
};
